<template>
    <div class="bg-white px-3">
        <div class="add_tits" ref="title">
            <el-form class="form-inlines " :inline="true">
                <el-form-item label="转账时间:">
                    <el-date-picker v-model="timess" type="daterange" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期" size='small' value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="接收者:">
                    <el-select v-model="doc_value" placeholder="请选择" clearable size="small" filterable>
                        <el-option v-for="item in  doc_options" :key="item.id" :label="item.nickname"
                            :value="item.nickname">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-plus" size="small" @click="adddata">添加</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
                <el-table-column prop="recipient_text" label="接受者" width="120" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="amount" label="转账金额（税后）" width="150" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="bank_card" label="银行卡" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="a" label="状态" width="100">
                    <template slot-scope="scope">
                        <span>{{({1:'已转账',2:'未转账'})[scope.row.status]}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="explain" label="转账说明" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="initiator" label="发起人" width="120" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="transfer_time" label="转账时间" width="110" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="a" label="转账截图">
                    <template slot-scope="scope">
                        <el-image style="width: 80px; height: 80px" v-for="(v,i) in scope.row.file" :key="i"
                            :src="v.url" fit="cover" :preview-src-list="[v.url]"></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="a" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button type="primary" class="editbtn" size="mini" @click="editdata(scope.row)">编辑
                        </el-button>
                        <el-button type="warning" size="mini" @click="deldata(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog :title="eid?'编辑':'新增'" :visible.sync="dialogVisible" center top="200px" width="40%" class="dialogs">
            <el-divider></el-divider>
            <div class="boxx">
                <el-form :model="formData" :rules="rule" ref="formData" label-width="150px"
                    class="demo-ruleForm forms-lines">
                    <el-form-item label="接收者" prop='recipient_id'>
                        <el-select v-model="formData.recipient_id" placeholder="请选择" clearable size="small" filterable>
                            <el-option v-for="item in  doc_options" :key="item.id" :label="item.nickname"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="转账金额" prop='amount'>
                        <el-input v-model="formData.amount" size="small" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="银行卡" prop='bank_card'>
                        <el-input v-model="formData.bank_card" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="状态" prop='status'>
                        <el-select v-model="formData.status" placeholder="请选择" size="small">
                            <el-option label="已转账" :value="1"></el-option>
                            <el-option label="未转账" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="转账说明" prop='explain'>
                        <el-input v-model="formData.explain" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="发起人" prop='initiator'>
                        <el-input v-model="formData.initiator" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="转账时间" prop='transfer_time'>
                        <el-date-picker v-model="formData.transfer_time" type="date" size="small"
                            value-format="yyyy-MM-dd" placeholder="选择开始日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="转账截图" required>
                        <el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
                            :headers="{ token:$store.state.user.token }" :data="{ image_class_id:'72',file_type:'1'}"
                            :file-list="formData.file" :on-success="uploadSuccess" :on-remove="uploadRmove"
                            list-type="picture-card">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit('formData')" size="small" type="primary" :loading="subloading">提 交</el-button>
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                timess: [],
                doc_value: '',
                formData: {
                    file: [],
                    recipient_id: '',
                    amount: '',
                    bank_card: '',
                    status: '',
                    explain: '',
                    initiator: '',
                    transfer_time: '',
                },
                user_options: [],
                rule: {
                    recipient_id: [{
                        required: true,
                        message: '请选择接收者',
                        trigger: 'blur'
                    }],
                    amount: [{
                        required: true,
                        message: '请填写转账金额',
                        trigger: 'blur'
                    }],
                    bank_card: [{
                        required: true,
                        message: '请填写银行卡',
                        trigger: 'blur'
                    }],
                    status: [{
                        required: true,
                        message: '请选择状态',
                        trigger: 'blur'
                    }],
                    // explain: [{
                    //     required: true,
                    //     message: '请填写转账说明',
                    //     trigger: 'blur'
                    // }],
                    initiator: [{
                        required: true,
                        message: '请填写发起人',
                        trigger: 'blur'
                    }],
                    transfer_time: [{
                        required: true,
                        message: '请选择时间',
                        trigger: 'blur'
                    }],
                    file: [{
                        required: true,
                        message: '请上传转账截图',
                        trigger: 'blur'
                    }],

                },
                mapListed: [],
                loading: false,
                tableData: [],
                currentPage: 1,
                pagesize: 15,
                count: 0,
                heights: null,
                date: xaoi.date,
                alluser: [],
                submsgloading: false,
                dialogVisible: false,
                eid: '',
                subloading: false,
                range: 100, //初始渲染条数基数
                filterTime: null, //自定义查询功能的节流定时器
                ry_options: [],
                ry_options_: [],
                doc_options: [],
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            this.getdoc()
            that.begin()
            that.getuser()
            that.getHeight()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 300 + 'px'
                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 300 + 'px'
                }
            },
            getdoc() {
                axios
                    .post("/admin/doctorAssistantList", {
                        type: 9
                    }, {
                        token: true
                    })
                    .then(response => {
                        this.doc_options = response.data.data
                    })
                    .catch(error => {})
            },

            loadMore() {
                //传入指令的增加渲染条数方法
                this.range += 50;
            },
            // 获取人员
            getuser() {
                let that = this;
                axios
                    .post(
                        `/admin/communityDoctor/moderatorUser`, {}, {
                            token: true,
                        }
                    )
                    .then((response) => {
                        that.ry_options = response.data.data;
                        this.ry_options_ = this.ry_options
                    })
                    .catch((error) => {});
            },
            selectFilter(val) {
                // 自定义下拉查询方法
                // if (this.filterTime) {
                //   clearTimeout(this.filterTime);
                //   this.filterTime = null;
                // }
                // this.filterTime = setTimeout(() => {
                console.log(val);
                if (val) {
                    let filterArr = this.ry_options.filter(item => {
                        return item.nickname.toLowerCase().includes(val.toLowerCase());
                    });
                    this.ry_options_ = filterArr;
                } else {
                    this.ry_options_ = this.ry_options

                }
                // }, 500);
            },
            selectVisible(v) {
                //下拉框显隐监听事件 控制渲染初始数据以及恢复总数据
                this.range = 100;
                if (!v) this.ry_options_ = this.ry_options;
            },
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/pc/Transfer/transferRecord", {
                        page: that.currentPage,
                        page_count: that.pagesize,
                        start_time: this.timess ? this.timess[0] : '',
                        end_time: this.timess ? this.timess[1] : '',
                        username: this.doc_value
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.total
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            adddata() {
                this.eid = ''
                this.dialogVisible = true
                this.cleardata()
            },
            cleardata() {
                this.formData.recipient_id = ''
                this.formData.amount = ''
                this.formData.bank_card = ''
                this.formData.status = ''
                this.formData.explain = ''
                this.formData.initiator = ''
                this.formData.transfer_time = ''
                this.formData.file = []
                this.mapListed = []
            },
            editdata(r) {
                this.dialogVisible = true
                this.eid = r.id
                this.formData.recipient_id = r.recipient_id
                this.formData.amount = r.amount
                this.formData.bank_card = r.bank_card
                this.formData.status = r.status
                this.formData.explain = r.explain
                this.formData.initiator = r.initiator
                this.formData.transfer_time = r.transfer_time
                this.formData.file = r.file
                this.mapListed = r.file
            },
            deldata(r) {
                let that = this
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios.post('/admin/pc/Transfer/del', {
                            id: r.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                that.search()
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            uploadSuccess(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.mapListed.push(response.data)
            },
            uploadRmove(file, fileList) {
                var index = this.mapListed.findIndex(item => item.id == file.id)
                this.mapListed.splice(index, 1)
            },
            //本月
            getDate6() {
                let that = this
                var date = new Date();
                date.setDate(1);
                var month = parseInt(date.getMonth() + 1);
                var day = date.getDate();
                month = month < 10 ? "0" + month : month;
                day = day < 10 ? "0" + day : day;
                var start = date.getFullYear() + "-" + month + "-" + day;
                var date = new Date();
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                month = month < 10 ? "0" + month : month;
                var day = new Date(year, month, 0);
                var end = year + "-" + month + "-" + day.getDate();
                this.formData.time = [start, end]
            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        that.subloading = true
                        let urls;
                        if (this.eid && this.eid != '0') {
                            urls = "/admin/pc/Transfer/update"
                        } else {
                            urls = "/admin/pc/Transfer/save"
                        }
                        this.formData.file = that.mapListed
                        axios.post(urls, {
                                id: that.eid,
                                ...this.formData
                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == '200') {
                                    that.dialogVisible = false
                                    that.search()
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                that.subloading = true
                            })
                    } else {
                        this.$alert("信息遗漏未填")
                        return false;
                    }
                });
            }
        },

    };
</script>


<style lang="scss" scoped>
    // .editbtn {
    //     background-color: #23BCCA;
    //     border-color: #23BCCA;
    // }
</style>